import { useContext } from 'react';
import { ThemeContext, type ThemeContextValue } from './ThemeProvider';

/** Reads/sets the app theme. Must be used under `<ThemeProvider>` (mounted once in main.tsx). */
export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return ctx;
}
